import axios from 'axios';

const state = {
  userVip: null,
  userXp: 0,
  currentLevel: null,
  vipLevels: [] // 🔹 Tüm VIP seviyeleri burada tutulacak
};

const mutations = {
  SET_VIP_DATA(state, { userVip, userXp, currentLevel, vipLevels }) {
    state.userVip = userVip;
    state.userXp = userXp;
    state.currentLevel = currentLevel;
    state.vipLevels = vipLevels || []; // 🔹 boş gelirse array yap
  }
};

const actions = {
  async fetchUserVip({ commit, rootGetters }) {
    const userId = rootGetters.authUser?.user?._id;
    if (!userId) return;

    try {
      const res = await axios.get(`/vip/user-level/${userId}`);
      commit('SET_VIP_DATA', {
        userVip: res.data.userVip,
        userXp: res.data.xp || 0,            // 🔹 Burada düzeltme
        currentLevel: res.data.currentLevel,
        vipLevels: res.data.levels || []
      });
    } catch (err) {
      console.error('VIP verisi alınamadı:', err);
    }
  }
};


const getters = {
  userVip: state => state.userVip,
  userXp: state => state.userXp,
  vipLevel: state => state.currentLevel,

  // 🔹 Bir sonraki seviyeyi bul
  nextVipLevel: (state) => {
    if (!state.currentLevel || !state.vipLevels.length) return null;
    return state.vipLevels.find(l => l.level === state.currentLevel.level + 1) || null;
  },

  // 🔹 Bir sonraki seviyeye kalan XP
  vipNextXp: (state, getters) => {
    const next = getters.nextVipLevel;
    if (!next) return 0;
    return Math.max(next.requiredXp - state.userXp, 0);
  },

  // 🔹 Progress hesaplama (bir sonraki level bazlı)
  vipProgress: (state, getters) => {
    const next = getters.nextVipLevel;
    if (!next || !next.requiredXp) return 100; // max level ise full
    const percent = (state.userXp / next.requiredXp) * 100;
    return Math.min(percent, 100).toFixed(2);
  },

  // 🔹 Görüntülenecek XP stringi (örn: 355 / 500)
  vipDisplayXp: (state, getters) => {
    const next = getters.nextVipLevel;
    if (!next || !next.requiredXp) return `${state.userXp} / MAX`;
    const current = Math.min(state.userXp, next.requiredXp);
    return `${current} / ${next.requiredXp}`;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
